import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './auth.guard';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { RecuperaMailComponent } from './recupera-mail/recupera-mail.component';
import { ProductoComponent } from './producto/producto.component';
import { DescuentoComponent } from './descuento/descuento.component';
import { DescuentoEditComponent } from './descuento-edit/descuento-edit.component';
import { ProductoEditComponent } from './producto-edit/producto-edit.component';
import { CategoriaComponent } from './categoria/categoria.component';
import { CategoriaEditComponent } from './categoria-edit/categoria-edit.component';
import { MonedaComponent } from './moneda/moneda.component';
import { MonedaEditComponent } from './moneda-edit/moneda-edit.component';
import { FormaPagoComponent } from './forma-pago/forma-pago.component';
import { FormaPagoEditComponent } from './forma-pago-edit/forma-pago-edit.component';
import { SistemaComponent } from './sistema/sistema.component';
import { ArqueoComponent } from './arqueo/arqueo.component';
import { TiendaComponent } from './tienda/tienda.component';
import { MetasComponent } from './metas/metas.component';
import { IngresosComponent } from './ingresos/ingresos.component';
import { ImprimeTicketComponent } from './imprime-ticket/imprime-ticket.component';
import { CancelaTicketComponent } from './cancela-ticket/cancela-ticket.component';
import { UltimosTicketsComponent } from './reportes/ultimos-tickets/ultimos-tickets.component';
import { AfluenciaComponent } from './reportes/afluencia/afluencia.component';
import { CancelacionesComponent } from './reportes/cancelaciones/cancelaciones.component';
import { IndicadoresSISCComponent } from './reportes/indicadores-sisc/indicadores-sisc.component';
import { IndicadoresSAACComponent } from './reportes/indicadores-saac/indicadores-saac.component';
import { IndicadoresTaquillaComponent } from './reportes/indicadores-taquilla/indicadores-taquilla.component';
import { IngresoComponent } from './reportes/ingreso/ingreso.component';
import { MetasEditComponent } from './metas-edit/metas-edit.component';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { UsuariosEditComponent } from './usuarios-edit/usuarios-edit.component';
import { PopupComponent } from './popup/popup.component';
import { CambioPwdComponent } from './cambio-pwd/cambio-pwd.component';
import { ValidaQrComponent } from './valida-qr/valida-qr.component';
import { AccesoQRComponent } from './acceso-qr/acceso-qr.component';
import { EditaFormaComponent } from './edita-forma/edita-forma.component';
import { PresConceptosComponent } from './pres-conceptos/pres-conceptos.component';
import { PresMovimientosComponent } from './pres-movimientos/pres-movimientos.component';
import { PresConceptosEditComponent } from './pres-conceptos-edit/pres-conceptos-edit.component';
import { PresMovimientosDetComponent } from './pres-movimientos-det/pres-movimientos-det.component';
import { NotaVentaComponent } from './reportes/nota-venta/nota-venta.component';
import { BaseComponent } from './reportesPres/base/base.component';
import { ValidaQrZebraComponent } from './valida-qr-zebra/valida-qr-zebra.component';
import { PrivAudioComponent } from './priv-audio/priv-audio.component';
import { AcepPolPrivComponent } from './acep-pol-priv/acep-pol-priv.component';
import { ServiciosTelmexComponent } from './servicios-telmex/servicios-telmex.component';
import { GrafupComponent } from './paginas/grafup/grafup.component';

const routes: Routes = [
 // { path: '', component: ValidaQrComponent, canActivate: [AuthGuard] },
  { path: '', component: ValidaQrZebraComponent, canActivate: [AuthGuard] },
 // { path: '', component: AcepPolPrivComponent},
  { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'grafPop', component: GrafupComponent },
  { path: 'recupwd/:u', component: RecuperaMailComponent },
  { path: 'c2Prod', component: ProductoComponent, canActivate: [AuthGuard]},
  { path: 'c2Desc', component: DescuentoComponent, canActivate: [AuthGuard]},
  { path: 'c2Cat', component: CategoriaComponent, canActivate: [AuthGuard]},
  { path: 'c2Mon', component: MonedaComponent, canActivate: [AuthGuard]},
  { path: 'c2Forma', component: FormaPagoComponent, canActivate: [AuthGuard]},
  { path: 'c2Met', component: MetasComponent, canActivate: [AuthGuard]},
  { path: 'c2Usr', component: UsuariosComponent, canActivate: [AuthGuard]},
  { path: 'editaProd', component: ProductoEditComponent, canActivate: [AuthGuard]},
  { path: 'editaDesc', component: DescuentoEditComponent, canActivate: [AuthGuard]},
  { path: 'editaCat', component: CategoriaEditComponent, canActivate: [AuthGuard]},
  { path: 'editaMon', component: MonedaEditComponent, canActivate: [AuthGuard]},
  { path: 'editaMeta', component: MetasEditComponent, canActivate: [AuthGuard]},
  { path: 'editaUser', component: UsuariosEditComponent, canActivate: [AuthGuard]},
  { path: 'editaForma', component: FormaPagoEditComponent, canActivate: [AuthGuard]},
  { path: 'arqueo', component: ArqueoComponent, canActivate: [AuthGuard]},
  { path: 'ingresos', component: IngresosComponent, canActivate: [AuthGuard]},
  { path: 'tienda', component: TiendaComponent, canActivate: [AuthGuard]},
  { path: 'c2Sys', component: SistemaComponent, canActivate: [AuthGuard]},
  { path: 'impTicket', component: ImprimeTicketComponent, canActivate: [AuthGuard]},
  { path: 'canTicket', component: CancelaTicketComponent, canActivate: [AuthGuard]},
  { path: 'editTicket', component: EditaFormaComponent, canActivate: [AuthGuard]},
  { path: 'r2Ultimos', component: UltimosTicketsComponent, canActivate: [AuthGuard]},
  { path: 'r2Aflu', component: AfluenciaComponent, canActivate: [AuthGuard]},
  { path: 'r2Cancela', component: CancelacionesComponent, canActivate: [AuthGuard]},
  { path: 'r2Taquilla', component: IndicadoresTaquillaComponent, canActivate: [AuthGuard]},
  { path: 'r2SISC', component: IndicadoresSISCComponent, canActivate: [AuthGuard]},
  { path: 'r2SAAC', component: IndicadoresSAACComponent, canActivate: [AuthGuard]},
  { path: 'r2Ingresos', component: IngresoComponent, canActivate: [AuthGuard]},
  { path: 'pop', component: PopupComponent, canActivate: [AuthGuard]},
  { path: 'cambioPwd', component: CambioPwdComponent, canActivate: [AuthGuard]},
  { path: 's2ValQR', component: ValidaQrComponent, canActivate: [AuthGuard]},
  { path: 's2ValZebraQR', component: ValidaQrZebraComponent, canActivate: [AuthGuard]},
  { path: 's2Acceso', component: AccesoQRComponent, canActivate: [AuthGuard]},
  { path: 'r2NotaVenta', component: NotaVentaComponent, canActivate: [AuthGuard]},
  { path: 'p2Concep', component: PresConceptosComponent, canActivate: [AuthGuard]},
  { path: 'editaConcep', component: PresConceptosEditComponent, canActivate: [AuthGuard]},
  { path: 'p2Mov', component: PresMovimientosComponent, canActivate: [AuthGuard]},
  { path: 'detMovimiento', component: PresMovimientosDetComponent, canActivate: [AuthGuard]},
  { path: 'p2RepBase', component: BaseComponent, canActivate: [AuthGuard]},
  { path: 'avisoPriv', component: PrivAudioComponent },
  { path: 'privacidad', component: AcepPolPrivComponent },
  { path: 'terminosServ', component: ServiciosTelmexComponent },
  { path: '**', redirectTo:''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
